<template>
    <TransitionGroup
        v-bind="$attrs"
        :tag="tag"
        :name="name"
        class="ui-motion-list"
        @before-leave="lockLeavingPosition"
    >
        <slot></slot>
    </TransitionGroup>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        tag: {
            type: String,
            default: 'div'
        },
        name: {
            type: String,
            default: 'ui-list'
        }
    },
    methods: {
        lockLeavingPosition(element) {
            const container = element.parentElement;
            if (!container) return;

            const elementRect = element.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            const containerStyle = window.getComputedStyle(container);
            const borderTop = parseFloat(containerStyle.borderTopWidth) || 0;
            const borderLeft = parseFloat(containerStyle.borderLeftWidth) || 0;
            const hasDirectOffsetParent = element.offsetParent === container;
            const top = hasDirectOffsetParent
                ? element.offsetTop
                : elementRect.top - containerRect.top - borderTop + container.scrollTop;
            const left = hasDirectOffsetParent
                ? element.offsetLeft
                : elementRect.left - containerRect.left - borderLeft + container.scrollLeft;

            Object.assign(element.style, {
                position: 'absolute',
                top: `${top}px`,
                left: `${left}px`,
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                margin: '0',
                boxSizing: 'border-box',
                pointerEvents: 'none',
                zIndex: '0'
            });
        }
    }
}
</script>
